/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useRouter } from "next/router";
import styled, { css } from "styled-components";
import media, { mediaMaxWidth } from "../utils/mediaQuery";
import Button from "./Buttons/Button";
import config from "../config";
import { useWindowResize } from "../utils/hooks";
import LogoLink from "./ApnaLogo/ApnaLogoLink";
import { getUrlPath } from "../utils/helpers";

const Header = ({ useNewEmployerHeader }) => {
	const router = useRouter();
	const [isMobileView] = useWindowResize();
	const trackEmployerLoginClick = async () => {
		const Mixpanel = await import("../utils/Mixpanel");
		Mixpanel.default.track("Homepage employer login click", {
			page: getUrlPath(),
		});
	};
	const trackPostJobClick = async () => {
		const Mixpanel = await import("../utils/Mixpanel");
		Mixpanel.default.track("Hompage post a job click", {
			page: getUrlPath(),
		});
	};
	const postJobUrl = `${config.dashboardUrl}/login?utm_source=${
		router?.query?.utm_source || "Website"
	}&utm_medium=${router?.query?.utm_medium || "Post%20Job%20Button"}&utm_campaign=${
		router?.query?.utm_campaign || "HomepageHeader"
	}`;
	const employerLoginUrl = `${config.dashboardUrl}/login?utm_source=${
		router?.query?.utm_source || "Website"
	}&utm_medium=${
		router?.query?.utm_medium || "Employer%20Login%20Button"
	}&utm_campaign=${router?.query?.utm_campaign || "HomepageHeader"}`;
	return (
		// eslint-disable-next-line react/jsx-no-useless-fragment
		<>
			{useNewEmployerHeader ? (
				isMobileView ? (
					<HeaderContainer>
						<LogoLink />
					</HeaderContainer>
				) : (
					<HeaderContainer sticky id="mobile-view-header-new-employer">
						<HeaderWrapper>
							<LogoTextContainer>
								<LogoTextWrapper>
									<LogoWrapper>
										<LogoLink />
									</LogoWrapper>
									<TextWrapper>
										<HeaderCityText>
											Currently live in Lucknow, Kanpur, Chennai,
											Chandigarh, Ludhiana, Kolkata, Surat,
											Hyderabad, Mumbai, Delhi-NCR, Bengaluru, Pune,
											Ahmedabad, Jaipur, and Ranchi
										</HeaderCityText>
									</TextWrapper>
								</LogoTextWrapper>
							</LogoTextContainer>
							<ButtonsTextWrapper>
								<TextWrapper>
									<Text>
										Hire candidate fast{" "}
										<span role="img" aria-labelledby="fast">
											⚡
										</span>
									</Text>
								</TextWrapper>
								<ButtonsWrapper>
									<PostJobBtn
										onClick={trackPostJobClick}
										as="a"
										href={postJobUrl}
										id="cta-banner-job-typeform-btn"
										target="_blank"
										rel="noopener noreferrer"
									>
										Post a Job now
									</PostJobBtn>
									<EmpLoginBtn
										onClick={trackEmployerLoginClick}
										secondary
										as="a"
										href={employerLoginUrl}
										id="cta-banner-employer-portal-btn"
										target="_blank"
										rel="noopener noreferrer"
									>
										Employer Login
									</EmpLoginBtn>
								</ButtonsWrapper>
							</ButtonsTextWrapper>
						</HeaderWrapper>
					</HeaderContainer>
				)
			) : (
				<HeaderContainer>
					<LogoLink />
				</HeaderContainer>
			)}
		</>
	);
};

// Styles
const HeaderWrapper = styled.div`
	margin: 0 auto;
	padding: 20px 15px;
	display: grid;
	grid-template-columns: 3fr 2fr;

	${media.medium`
        max-width: 720px;
    `};
	${media.large`
        max-width: 960px;
    `};
	${media.extraLarge`
        max-width: 1140px;
    `};
`;
const LogoTextContainer = styled.div``;
const LogoTextWrapper = styled.div`
	display: flex;
	align-items: center;
`;
const LogoWrapper = styled.div``;
const TextWrapper = styled.div``;
const HeaderCityText = styled.p`
	font-size: 14px;
	font-weight: 500;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.29;
	letter-spacing: normal;
	color: #ffffff;
	margin-bottom: 0;
	margin-left: 12px;
`;
const Text = styled.p`
	font-size: 14px;
	font-weight: 500;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.29;
	letter-spacing: normal;
	text-align: center;
	color: #ffffff;
	margin-bottom: 0;
`;
const ButtonsTextWrapper = styled(LogoTextWrapper)`
	justify-self: end;
`;

const PostJobBtn = styled(Button)`
	display: inline-block;
	height: 32px;
	line-height: 33px;
	font-size: 14px;
	text-decoration: none;
	padding: 0px 12px;
`;
const EmpLoginBtn = styled(Button)`
	display: inline-block;
	height: 32px;
	line-height: 32px;
	font-size: 14px;
	color: #fff;
	border-color: #fff;
	text-decoration: none;
	padding: 0px 12px;
`;

const ButtonsWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 12px;
	& ${EmpLoginBtn} {
		font-size: 12px;
	}
	& ${PostJobBtn} {
		font-size: 12px;
	}
	${media.extraLarge`
		grid-template-columns: 1fr 1fr;
	`};
`;
const HeaderContainer = styled.header`
	padding: 50px 15px;
	margin: 0 auto;

	${media.extraSmall`
        max-width: 100%;
    `};
	${media.small`
        max-width: 540px;
    `};
	${media.medium`
        max-width: 720px;
		svg{
			cursor: pointer;
		}
    `};
	${media.large`
        max-width: 100%;
    `};
	${media.extraLarge`
        max-width: 100%;
    `};

	${({ sticky }) =>
		sticky
			? css`
					position: sticky;
					top: 0;
					background-color: #2e2230;
					padding: 0;
					z-index: 10000;

					& ${Text} {
						margin-left: 15px;
					}
					& ${ButtonsTextWrapper} ${Text} {
						margin-right: 15px;
					}
			  `
			: css`
					position: static;

					${media.large`
						max-width: 960px;
					`};
					${media.extraLarge`
						max-width: 1140px;
					`};
			  `};

	${mediaMaxWidth.large`
		text-align: center;
		padding-bottom: 15px;
		padding-top: 20px;
	`}
	${mediaMaxWidth.medium`
		&#mobile-view-header-new-employer {
			display: none;
		}
	`}

	& svg {
		box-shadow: 0 8px 20px 0px rgba(0, 0, 0, 0.17);
		border-radius: 11px;
		width: 56px;
		height: 56px;

		${media.medium`
			border-radius: 16px;
			width: 70px;
			height: 70px;
		`};
	}
`;

export default Header;
